export default __webpack_public_path__ + "static/media/f_2.01f46694.jpg";